export const interior_view04ImageOptions = {
  angle: 'interior_view04',
  staticOptions: {
    Floorboard: 1,
    Fabric: 1,
    Worktop: 1,
    FabricOwnersCabin: 1,
    BedsideCompartment: 1,
    AftCabinLayout: 1,
    Mast: 1,
    Wheel: 1,
    FabricSeatOwnersCabin: 1,
    FabricFreehung: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    },
    {
      option: 'BedsideCompartment',
      dependency: 'Veneer'
    },
    {
      option: 'FabricSeatOwnersCabin',
      dependency: 'Wardrobe'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/interior_view04.js